/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined' || import.meta.env.SSR;

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.product = (await import('./pages/product/ProductContainer')).ProductContainer;
    Components.productMobile = (await import('./pages/product/ProductMobileContainer')).ProductMobileContainer;
    Components.configuratorProjects = (await import('./pages/configurator-projects/ConfiguratorProjects')).ConfiguratorProjects;
    Components.findYourFlooring = (await import('./pages/find-your-flooring/FindYourFlooring')).FindYourFlooring;
    Components.home = (await import('./pages/Home')).Home;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  product: {
    name: 'ProductContainer',
    componentName: 'ProductContainer',
    chunk: () => import(
      './pages/product/ProductContainer' // eslint-disable-line
    ),
    get component() {
      return ssr
        ? serverPages.product
        : currentRouteName === 'ProductContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.ProductContainer })));
    },
    path: '/:context?/p/:slug?/:itemId',
    prefetch: ['browse'],
    channel: 'desktop'
  },
  productMobile: {
    name: 'ProductMobileContainer',
    componentName: 'ProductMobileContainer',
    chunk: () => import(
      './pages/product/ProductMobileContainer' // eslint-disable-line
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.productMobile
        : currentRouteName === 'ProductMobileContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.ProductMobileContainer })));
    },
    path: '/:context?/p/:slug?/:itemId',
    prefetch: ['browseMobile'],
    channel: 'mobile'
  },
  configuratorProjects: {
    name: 'ConfiguratorProjects',
    componentName: 'ConfiguratorProjects',
    chunk: () => import(
      './pages/configurator-projects/ConfiguratorProjects' // eslint-disable-line
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.configuratorProjects
        : currentRouteName === 'ConfiguratorProjects'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.ConfiguratorProjects })));
    },
    path: '/:context?/configurator-projects',
    channel: null
  },
  findYourFlooring: {
    name: 'FindYourFlooring',
    componentName: 'FindYourFlooring',
    chunk: () => import(
      './pages/find-your-flooring/FindYourFlooring' // eslint-disable-line
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.findYourFlooring
        : currentRouteName === 'FindYourFlooring'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.FindYourFlooring })));
    },
    path: '/:context?/find-your-flooring',
    channel: null
  },
  home: {
    name: 'Home',
    componentName: 'Home',
    chunk: () => import(
      './pages/Home' // eslint-disable-line
    ),
    get component() {
      return ssr
        ? serverPages.home
        : currentRouteName === 'Home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/',
    channel: null
  }
});

export const getRouteChunk = async (currentRouteName) => {
  const routes = getRoutes();
  const routeKey = Object.keys(routes).filter((key) => routes[key].name === currentRouteName)[0];
  const route = routes[routeKey];
  const componentModule = await route.chunk();

  return componentModule[route.componentName];
};
